export default defineNuxtPlugin(() => {
  const heightMap = {} as Record<string, number>
  const router = useRouter()
  const store = useStore()

  // Helps the browser to keep the scroll position the same, when a user navigates back to a certain page.
  // By storing the initial height (when page loads), we capture the default state,
  // which matches the state when returning to the page later.
  router?.beforeEach((to: any, from: any, next: any) => {
    if (to.fullPath !== from.fullPath) {
      // Set the stored height for the destination page (if we have one)
      store.value.pageHeight = heightMap[to.fullPath] || 0
    }

    next()
  })

  // Store the page height after it has fully loaded in its initial state
  router?.afterEach((to: any) => {
    // Wait for the page to render and settle into its default state
    setTimeout(() => {
      const currentHeight = document.body.clientHeight

      // Only store if we don't have a height yet or if this is a fresh visit
      // This captures the page in its initial/default state
      if (!heightMap[to.fullPath]) {
        heightMap[to.fullPath] = currentHeight
      }

      // Clear the artificial height after scroll restoration
      store.value.pageHeight = 0
    }, 300)
  })
})
